import {
  Container,
  Description,
  Content,
  Fill,
  Align,
  Section,
} from "./styles";
import { Title, Custom, P } from "../../constants/type.js";

const Hero = ({ message, title, onClick, connect }) => {
  return (
    <Container>
      <Content>
        <Title fontSize="120px" color="primary">
          {title}
        </Title>
        <Section>
          <Fill onClick={onClick}>Connect Wallet</Fill>
        </Section>
      </Content>
    </Container>
  );
};

export default Hero;
